module.exports = __webpack_public_path__ + "img/lk.7a136cf7.svg";